import React from 'react';
import { isEmpty, get } from 'lodash';
import PropTypes from 'prop-types';
import { compose, withStateHandlers } from 'recompose';
import { withFixedSegmentCategory } from '@sparefoot/react-core/segment';

import { GoogleMap } from 'components/core/GoogleMap';

import { FacilityMarker } from 'components/facility/FacilityMarker';


import './CardMap.scss';

export const enhance = compose(
	withFixedSegmentCategory('map interactions'),
	withStateHandlers({
		selectedFacility: null
	}, {
		handleFacilityMarkerClick: () => (selectedFacility) => ({ selectedFacility })
	})
);

export function CardMap({
	facilities,
	handleFacilityMarkerClick,
	selectedFacility
}) {
	return (
		<div className="card-map">
			{!isEmpty(facilities) &&
				<GoogleMap
					center={get(facilities, '0.location')} // this will force to center between the facilities on map
					locationBounds={facilities.map((facility) => facility.location)}
					radius={5}
				>
					{facilities.map((facility) => (
						<FacilityMarker
							key={facility.id}
							facility={facility}
							selected={selectedFacility === facility.id}
							onClick={handleFacilityMarkerClick}
							segmentCategory="map interactions"
						/>
					))}
				</GoogleMap>
			}
		</div>
	);
}

CardMap.propTypes = {
	facilities: PropTypes.arrayOf(PropTypes.object).isRequired,
	handleFacilityMarkerClick: PropTypes.func.isRequired,
	selectedFacility: PropTypes.number
};

export default enhance(CardMap);
